<div class="tw-flex tw-flex-col tw-gap-4">
  <div class="tw-flex tw-w-full tw-items-center tw-px-6 tw-py-3">
    <span
      class="tw-ml-2 tw-text-lg tw-font-semibold tw-uppercase tw-text-dt-text-secondary sm:tw-text-sm"
    >
      account balances
    </span>
  </div>
  <div
    id="bubble-chart"
    class="bubble-chart tw-bg-dt-surface-elevated dark:tw-bg-color-surface-card tw-rounded-3xl"
  ></div>
</div>
